import { render, staticRenderFns } from "./BeNotification.vue?vue&type=template&id=182530e8&"
import script from "./BeNotification.vue?vue&type=script&lang=js&"
export * from "./BeNotification.vue?vue&type=script&lang=js&"
import style0 from "./BeNotification.vue?vue&type=style&index=0&id=182530e8&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports